import React from 'react';
import Drawer from 'material-ui/Drawer';
import {Link, withRouter} from 'react-router-dom'
import {ListItem} from "material-ui";
import {DS} from '../../theme-default';

const SIDEBAR_TEXT = '#dfe8f3';
const SIDEBAR_TEXT_MUTED = '#9dc0ea';
const SIDEBAR_DIVIDER = 'rgba(255, 255, 255, 0.12)';
const SIDEBAR_ACTIVE_BG = 'rgba(255, 255, 255, 0.14)';

// "/app" (Home) only highlights on an exact match; every other entry also
// matches its sub-pages (e.g. /app/referate/0 -> /app/referate/3).
function isMenuActive(menuLink, pathname) {
    if (menuLink === '/app') {
        return pathname === '/app' || pathname === '/app/';
    }
    const base = menuLink.replace(/\/\d+$/, '');
    return pathname === menuLink || pathname === base || pathname.indexOf(base + '/') === 0;
}

const LeftDrawer = (props) => {
    let {navDrawerOpen, docked} = props;

    const styles = {
        logo: {
            cursor: 'pointer',
            fontSize: 18,
            color: '#ffffff',
            lineHeight: '57px',
            fontWeight: 600,
            borderBottom: `1px solid ${SIDEBAR_DIVIDER}`,
            paddingLeft: 24,
            height: 57,
        },
        menuItem: {
            color: SIDEBAR_TEXT,
            fontSize: 14
        },
        avatar: {
            div: {
                padding: '15px 15px 15px 24px',
                backgroundColor: 'rgba(255, 255, 255, 0.06)',
                borderBottom: `1px solid ${SIDEBAR_DIVIDER}`
            },
            span: {
                display: 'block',
                color: '#ffffff',
                fontWeight: 600,
                fontSize: 14
            },
            emailText: {
                fontSize: 12,
                paddingTop: 4,
                display: 'block',
                color: SIDEBAR_TEXT_MUTED,
                fontWeight: 400
            }
        }
    };

    return (
        <Drawer
            width={200}
            docked={docked}
            onRequestChange={props.onRequestChange}
            containerStyle={{
                background: `linear-gradient(180deg, ${DS.primaryDeep} 0%, ${DS.primaryDark} 100%)`,
                boxShadow: docked ? 'none' : undefined
            }}
            open={navDrawerOpen}>
            <div style={styles.logo}>
                Achiziții Publice
            </div>
            <div style={styles.avatar.div}>
                <span style={styles.avatar.span}>{props.username}</span>
                <span style={styles.avatar.emailText}>{props.email}</span>
            </div>
            <div className="ds-sidebar-menu">
                {props.menus.map((menu, index) => {
                    const active = isMenuActive(menu.link, props.location.pathname);
                    return (
                        <ListItem
                            key={index}
                            style={{
                                ...styles.menuItem,
                                textAlign: 'left',
                                ...(active
                                    ? {
                                          color: '#ffffff',
                                          fontWeight: 600,
                                          backgroundColor: SIDEBAR_ACTIVE_BG,
                                          borderLeft: `3px solid ${SIDEBAR_TEXT_MUTED}`
                                      }
                                    : {borderLeft: '3px solid transparent'})
                            }}
                            primaryText={menu.text}
                            rightAvatar={menu.icon}
                            onClick={props.onNavigate}
                            containerElement={<Link to={menu.link}/>}
                        />
                    );
                })}
            </div>
        </Drawer>
    );
};

export default withRouter(LeftDrawer);
